import Service from "../../services";

const statusModule = {
    namespaced: true,
    state: { list: [] },
    mutations: {
        SET_ALL: (state, data) => {
            state.list = data;
        }
    },
    actions: {
        setAll({ commit }) {
            Service.cancelReason.CancelReason().then(res => {
                commit("SET_ALL", res);
            });
        },
        async getReasonList({commit}) {
            return Service.cancelReason.getSetting();
        },
        async createReason({commit}, payload) {
            let confirmPassword = await Service.auth.confirmPassword(
                payload
            );

            if (confirmPassword.confirm_password) {
                let token = confirmPassword.token;
                return Service.cancelReason.createSetting(payload, token);
            } else {
                return false
            }
        },
        async updateReason({commit}, data) {
            let confirmPassword = await Service.auth.confirmPassword(
                data
            );

            if (confirmPassword.confirm_password) {
                let token = confirmPassword.token;
                return Service.cancelReason.updateSetting(data.payload, data.id, token);
            } else {
                return false
            }
        },
        async deleteReason({commit}, data) {
            let confirmPassword = await Service.auth.confirmPassword(
                data
            );

            if (confirmPassword.confirm_password) {
                let token = confirmPassword.token;
                return Service.cancelReason.deleteSetting(data.id, token);

            } else {
                return false
            }
        },
    },
    getters: {
        getAll(state) {
            return state.list;
        }
    }
};
export default statusModule;
